import React from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Stack,
  Avatar,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const metricCards = [
  {
    title: "Yard Cameras",
    value: "20",
    accent: "#2b5fb8",
    sub: "View details",
    icon: "demo1.png",
    badgeText: "val",
  },
  {
    title: "Truck Yard Sites",
    value: "9",
    accent: "#2f5f68",
    sub: "View details",
    icon: "demo2.png",
    badgeText: "3.",
  },
  {
    title: "Unique Tractors (20/NH)",
    value: "341",
    accent: "#3b6b47",
    sub: "View details",
    icon: "demo3.png",
  },
  {
    title: "Overnight/ Orstay Alerts",
    value: "134",
    accent: "#8b2e41",
    sub: "View details",
    icon: "demo4.png",
  },
];

const tabs = ["All sites", "Overnight", "Trailer Only", "Overstay", "Missing DOT"];

const tableRows = [
  {
    site: "Columbia",
    zone: "Entry Lane",
    plate: "P784567",
    usdot: "0481220",
    trailer: "TLR8390",
    vehicle: "Tractor + Trailer",
    direction: "Entering",
    time: "7:13 AM",
    tag: "Overnight",
  },
  {
    site: "Houston",
    zone: "Exit Lot",
    plate: "TYNG949",
    usdot: "Not Detected",
    trailer: "No Trailer Detected",
    vehicle: "Main North | Cam 13",
    direction: "Exiting",
    time: "5:38 AM",
    badge: "Not Detected",
    tag: "Missing DOT",
  },
  {
    site: "Columbia",
    zone: "Back Lot",
    plate: "HZ02386",
    usdot: "6786717",
    trailer: "TLR8692",
    vehicle: "Lot North | Cam 16",
    direction: "Drop",
    time: "4:47 AM",
    tag: "Trailer Only",
  },
  {
    site: "Columbia",
    zone: "Main West",
    plate: "S729DPZ",
    usdot: "8356220",
    trailer: "Drop",
    vehicle: "Lot North | Cam 16",
    direction: "Drop",
    time: "5:52 AM",
    tag: "Overstay",
  },
  {
    site: "Columbia",
    zone: "Entry Lane",
    plate: "F13456X",
    usdot: "7662762",
    trailer: "TLR8966",
    vehicle: "Entry Lane | Cam 08",
    direction: "Exiting",
    time: "3:07 AM",
    tag: "Overnight",
  },
  {
    site: "Fargo",
    zone: "Exit Lane",
    plate: "JD14837",
    usdot: "Yard Gate | Cam 09",
    trailer: "Exit Lane",
    vehicle: "Yard Gate",
    direction: "Entry Lane",
    time: "2:44 AM",
    tag: "Trailer Only",
  },
  {
    site: "Columbia",
    zone: "Entry Lane",
    plate: "K22397M",
    usdot: "Lot Assist E",
    trailer: "Exit Lane",
    vehicle: "Exit Lane | Cam 06",
    direction: "Exit Lane",
    time: "11:25 PM",
    tag: "Missing DOT",
  },
  {
    site: "Columbia",
    zone: "Exit Lot",
    plate: "N78DXHK",
    usdot: "Yard Gate | Cam 09",
    trailer: "Exit Lane",
    vehicle: "Yard Gate",
    direction: "Yard Exit",
    time: "7:06 PM",
    tag: "Overnight",
  },
  {
    site: "Columbia",
    zone: "Lot Assist E",
    plate: "D414869",
    usdot: "Entry Lane",
    trailer: "Yard Gate",
    vehicle: "Exit Lane | Cam 08",
    direction: "Exit Lane",
    time: "7:06 PM",
    tag: "Trailer Only",
  },
  {
    site: "Columbia",
    zone: "Bet Gate",
    plate: "DD44169A",
    usdot: "Yard Gate",
    trailer: "Entry Lane",
    vehicle: "Yard Gate",
    direction: "5:36 PM",
    time: "5:36 PM",
    tag: "Overstay",
  },
  {
    site: "Columbia",
    zone: "Exit Lane",
    plate: "D414869",
    usdot: "Entry Lane & Lot A",
    trailer: "Exit Lane",
    vehicle: "Exit Lane | Cam 02",
    direction: "Exit Lane",
    time: "3:48 PM",
    tag: "Overstay",
  },
  {
    site: "Columbia",
    zone: "Yard Gate",
    plate: "D441687",
    usdot: "Yard Gate",
    trailer: "Entry Lane",
    vehicle: "Entry Lane",
    direction: "13:48 PM",
    time: "13:48 PM",
    badge: "13:48 PM",
    tag: "Missing DOT",
  },
];

const alerts = [
  {
    site: "Columbia",
    plate: "TYM6543",
    note: "Missing DOT",
    time: "5:45 AM",
    dot: "#5ca4ff",
  },
  {
    site: "Houston",
    plate: "P466788",
    note: "Trailer Detected Overnight",
    time: "5:56 AM",
    dot: "#5ca4ff",
  },
  {
    site: "Columbia",
    plate: "P784667",
    note: "Overstay Detected",
    time: "5:34 AM",
    dot: "#f1c04b",
  },
  {
    site: "Columbia",
    plate: "F18466X",
    note: "Overstay Detected",
    time: "5:09 AM",
    dot: "#f1c04b",
  },
  {
    site: "Columbia",
    plate: "S111983",
    note: "Repeat Overnight Tractor",
    time: "2:44 AM",
    dot: "#5ca4ff",
  },
];

const topSites = [
  { site: "Columbia", value: 56, color: "#e05663", iconColor: "#e05663" },
  { site: "Houston", value: 34, color: "#4f91ff", iconColor: "#4f91ff" },
  { site: "Atlanta", value: 26, color: "#6aa1ff", iconColor: "#6aa1ff" },
];

export default function DashboardDemo() {
  const [activeTab, setActiveTab] = React.useState(0);
  const [searchValue, setSearchValue] = React.useState("");
  const [searchTouched, setSearchTouched] = React.useState(false);
  const [dialog, setDialog] = React.useState({ open: false, message: "" });

  const activeTabLabel = tabs[activeTab];
  const filteredRows =
    activeTabLabel === "All sites"
      ? tableRows
      : tableRows.filter((row) => row.tag === activeTabLabel);

  const openDialog = (message) => {
    //setDialog({ open: true, message });
  };

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet(activeTabLabel);
    sheet.columns = [
      { header: "Site", key: "site", width: 16 },
      { header: "Camera / Zone", key: "zone", width: 18 },
      { header: "Tractor Plate", key: "plate", width: 16 },
      { header: "USDOT Number", key: "usdot", width: 16 },
      { header: "Trailer ID", key: "trailer", width: 16 },
      { header: "Vehicle Type", key: "vehicle", width: 22 },
      { header: "Direction", key: "direction", width: 14 },
      { header: "Emeint 1?", key: "time", width: 12 },
    ];

    filteredRows.forEach((row) => {
      sheet.addRow({
        site: row.site,
        zone: row.zone,
        plate: row.plate,
        usdot: row.badge ? row.badge : row.usdot,
        trailer: row.trailer,
        vehicle: row.vehicle,
        direction: row.direction,
        time: row.time,
      });
    });

    sheet.getRow(1).font = { bold: true };

    const buffer = await workbook.xlsx.writeBuffer();
    const safeTab = activeTabLabel.toLowerCase().replace(/\s+/g, "-");
    saveAs(
      new Blob([buffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      `truck-trailer-${safeTab}.xlsx`
    );
  };

  return (
    <>
      <Box
        sx={{
          // background: "#1b1e27",
          // borderRadius: "22px",
          // p: 3.5,
          // boxShadow: "0 28px 70px rgba(10, 12, 20, 0.45)",
          // border: "1px solid rgba(255,255,255,0.05)",
          background: "#1A1A1A",
          p:2
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2.5}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                //gap: 1,
                background: "#11131a",
                borderRadius: 1,
                px: 1.5,
                py: 1,
                width: 280,
                boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.05)",
              }}
            >
              <TextField
                variant="standard"
                placeholder="Quick search..."
                value={searchValue}
                onChange={(event) => setSearchValue(event.target.value)}
                onFocus={() => setSearchTouched(true)}
                InputProps={{
                  disableUnderline: true,
                  sx: { color: "#e6e8ee", fontSize: 13 },
                  endAdornment: (
                    <InputAdornment position="end" sx={{ mr: -1.5 }}>
                      <IconButton
                        size="small"
                        onClick={() => openDialog("Search clicked (test action).")}
                        sx={{
                          width: 40,
                          height: 40,
                          m: 0,
                          background: "#2b68c4",
                          color: "#fff",
                          borderRadius: "0 4px 4px 0", // Top left and top right radius 0, bottom left & right 4px
                          "&:hover": { background: "#255ab0" },
                        }}
                      >
                        <SearchIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
              
            </Box>
          </Stack>
         
        </Stack>

        <Typography sx={{ fontSize: 26, fontWeight: 600, mb: 2 }}>
          Truck & Trailer Intelligence
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            gap: 2,
            mb: 2.5,
          }}
        >
          {metricCards.map((card) => (
            <Paper
              key={card.title}
              onClick={() => openDialog(`You clicked on ${card.title}.`)}
              sx={{
                borderRadius: 0.5,
                p: 2,
                minHeight: 110,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                boxShadow: "0 14px 30px rgba(4, 6, 12, 0.35)",
                color: "#f2f4f8",
                cursor: "pointer",
                overflow: "hidden",
                position: "relative",
                background: `linear-gradient(135deg, ${card.accent} 0%, #1d212c 70%)`,
              }}
              elevation={0}
            >
              <Stack spacing={0.4}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography sx={{ fontSize: 28, fontWeight: 700 }}>{card.value}</Typography>
                </Stack>
                <Typography sx={{ fontSize: 13, opacity: 0.9 }}>{card.title}</Typography>
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  mx: -2,
                  mb: -2,
                  mt: 1.5,
                  px: 3,
                  pt: 1,
                  pb: 1,
                  background: "#1A1A1A",
                }}
              >
                <Typography sx={{ fontSize: 13, color: "#7eb6ff" }}>{card.sub}</Typography>
                <Avatar
                  sx={{
                    width: 18,
                    height: 18,
                    color:'#fff',
                    bgcolor: "#7eb6ff",
                    fontSize: 11,
                  }}
                >
                  i
                </Avatar>
              </Stack>
              <Box
                sx={{
                  position: "absolute",
                  right: 12,
                  top: 0,
                  opacity: 0.18,
                  pointerEvents: "none",
                }}
              >
                  <img
                    src={`/static/${card.icon}`}
                    alt="yard cameras"
                    style={{
                      width: 80,
                      height: 80,
                      objectFit: "contain",
                      opacity: 1,
                    }}
                  />
              </Box>
            </Paper>
          ))}
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) 320px",
            gap: 2.25,
          }}
        >
          <Paper
            elevation={0}
            sx={{
              background: "linear-gradient(180deg, rgba(42,45,57,0.9), rgba(28,31,42,0.95))",
              borderRadius: 1,
              p: 0.5,
              border: "1px solid rgba(255,255,255,0.05)",
              boxShadow: "0 16px 35px rgba(29, 28, 28, 0.4)",
            }}
          >
            <Stack direction="row" justifyContent="space-between" mb={0.5}>
              <Tabs
                value={activeTab}
                onChange={(_, value) => setActiveTab(value)}
                textColor="inherit"
                TabIndicatorProps={{ style: { display: "none" } }}
                sx={{
                  minHeight: "auto",
                  p: 0,
                  background: "#1c1f29",
                  borderRadius: 0.8,
                  border: "1px solid rgba(255,255,255,0.05)",
                  "& .MuiTab-root": {
                    minHeight: "auto",
                    textTransform: "none",
                    fontSize: 13,
                    color: "#c7cbd8",
                    borderRadius: 0.6,
                    mx: 0.3,
                    px: 1.6,
                    py: 0.6,
                    minHeight: 30,
                    border: "1px solid transparent",
                  },
                  "& .Mui-selected": {
                    color: "#fff",
                    background: "#000",
                    borderColor: "rgba(255,255,255,0.08)",
                  },
                }}
              >
                {tabs.map((tab, index) => (
                  <Tab
                    key={tab}
                    label={
                      <Stack direction="row" alignItems="center" spacing={0.5}>
                        <Typography sx={{ fontSize: 13 }}>{tab}</Typography>
                        {(index === 0 || index === tabs.length - 1) && (
                          <KeyboardArrowDownIcon sx={{ fontSize: 16, opacity: 0.7 }} />
                        )}
                      </Stack>
                    }
                  />
                ))}
              </Tabs>
              <Button
                variant="contained"
                onClick={handleExport}
                sx={{
                  backgroundColor: "#000",
                  borderColor: "rgba(255,255,255,0.1)",
                  color: "#c2c7d6",
                  textTransform: "none",
                  fontSize: 12,
                  px: 1.5,
                  "&:hover": { 
                    borderColor: "rgba(255,255,255,0.2)",
                    backgroundColor: "#111", // subtle hover effect if desired
                  },
                }}
              >
                Export to Excel <KeyboardArrowDownIcon sx={{ fontSize: 16, opacity: 0.7 }} />
              </Button>
            </Stack>
            <TableContainer
              component={Box}
              sx={{
                maxHeight: 520,
                background: "#141722",
                border: "1px solid rgba(255,255,255,0.06)",
              }}
            >
              <Table
                stickyHeader
                size="small"
                sx={{
                  minWidth: 650,
                  "& .MuiTableCell-head": {
                    background: "#0b0d12",
                    color: "#ffffff",
                    fontWeight: 600,
                    borderBottomColor: "rgba(255,255,255,0.12)",
                  },
                  "& .MuiTableCell-body": {
                    color: "#e1e4ec",
                    borderBottomColor: "rgba(255,255,255,0.06)",
                  },
                  "& .MuiTableRow-root:nth-of-type(odd) .MuiTableCell-body": {
                    background: "#171a26",
                  },
                  "& .MuiTableRow-root:nth-of-type(even) .MuiTableCell-body": {
                    background: "#141722",
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>
                      Site
                    </TableCell>
                    <TableCell>
                      Camera / Zone
                    </TableCell>
                    <TableCell>
                      Tractor Plate
                    </TableCell>
                    <TableCell>
                      USDOT Number
                    </TableCell>
                    <TableCell>
                      Trailer ID
                    </TableCell>
                    <TableCell>
                      Vehicle Type
                    </TableCell>
                    <TableCell>
                      Direction
                    </TableCell>
                    <TableCell>
                      Emeint
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredRows.map((row, index) => (
                    <TableRow key={`${row.site}-${index}`}>
                      <TableCell>
                        {row.site}
                      </TableCell>
                      <TableCell>
                        {row.zone}
                      </TableCell>
                      <TableCell sx={{ color: "#84b7ff" }}>
                        {row.plate}
                      </TableCell>
                      <TableCell>
                        {row.badge === "Not Detected" ? (
                          <Chip
                            label={row.badge}
                            size="small"
                            sx={{
                              background: "#7a3f1f",
                              color: "#f5d3b3",
                              fontSize: 11,
                              height: 22,
                            }}
                          />
                        ) : (
                          row.usdot
                        )}
                      </TableCell>
                      <TableCell>
                        {row.trailer}
                      </TableCell>
                      <TableCell>
                        {row.vehicle}
                      </TableCell>
                      <TableCell>
                        {row.direction}
                      </TableCell>
                      <TableCell>
                        {row.time}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

          <Stack spacing={1.75}>
        <Paper
  elevation={0}
  sx={{
    background: "linear-gradient(180deg, rgba(42,45,57,0.9), rgba(28,31,42,0.95))",
    borderRadius: 1,
    border: "0px solid rgba(255,255,255,0.05)",
    boxShadow: "0 16px 35px rgba(0,0,0,0.4)",
  }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      p: 1.2,
      mt:0.2,
      mb: 0.2,
    }}
  >
    <InfoOutlinedIcon sx={{ fontSize: 18, color: "#cbd0dd" }} />
    <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
      Overnight & Compliance Alerts
    </Typography>
  </Box>
  <Stack spacing={0.5} sx = {{backgroundColor: "#171a26"}}>
    {alerts.map((alert, index) => (
      <Stack
        key={`${alert.site}-${index}`}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          px:1,
          py: 0.8,
          borderBottom: "1px solid rgba(255,255,255,0.06)",
        }}
      >
        <Box>
          <Stack direction="row" alignItems="center" spacing={0.75}>
            <Box
              sx={{
                width: 7,
                height: 7,
                borderRadius: 0.6,
                background: alert.dot,
              }}
            />
            <Typography sx={{ fontWeight: 600, fontSize: 13 }}>
              {alert.site}
            </Typography>
          </Stack>
          <Typography sx={{ fontSize: 12, color: "#B1D6FE" }}>
              {alert.plate} <span style={{ color: index === 2 || index === 3 ? 'red' : index === 4 ? '#adb2bf' : '#9fc3ff' }}>({alert.note})</span>
          </Typography>
        </Box>
        <Typography sx={{ color: "#c2c8d6", fontSize: 13 }}>
          {alert.time}
        </Typography>
      </Stack>
    ))}
  </Stack>
  <Button
    variant="text"
    onClick={() => openDialog("View all alerts clicked (test action).")}
    sx={{
      color: "#7eb6ff",
      textTransform: "none",
      fontSize: 14,
      mt: 0.2,
      alignSelf: "center",
    }}
    fullWidth
  >
    View all alerts  <KeyboardArrowRightIcon sx={{ fontSize: 16, opacity: 0.7 }} />
  </Button>
</Paper>

            <Paper
              elevation={0}
              sx={{
                background: "linear-gradient(180deg, rgba(42,45,57,0.9), rgba(28,31,42,0.95))",
                borderRadius: 1,
                boxShadow: "0 16px 35px rgba(0,0,0,0.4)",
              }}
            >
              <Stack direction="row" alignItems="center" spacing={1} sx={{ mt:0.2, mb: 0.2, p:1 }}>
                <NotificationsNoneIcon sx={{ fontSize: 18, color: "#cbd0dd" }} />
                <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
                  Top Alert Sites this Week
                </Typography>
              </Stack>
              
              <Stack direction="row" spacing={2} justifyContent="space-between" sx={{backgroundColor: "#171a26", p:1}}>
                {topSites.map((item) => (
                  <Paper
                    key={item.site}
                    elevation={0}
                    sx={{
                      flex: 1,
                      background: "transparent",
                      borderRadius: 0,
                      p: 0,
                      textAlign: "center",
                    }}
                  >
                    <Typography sx={{ fontSize: 12, color: "#e1e4ec", mb: 0.5 }}>
                      {item.site}
                    </Typography>
                    <Stack direction="row" spacing={0.6} alignItems="baseline" justifyContent="center">
                      <NotificationsActiveIcon sx={{ fontSize: 18, color: item.iconColor }} />
                      <Typography
                        sx={{
                          fontSize: 26,
                          color: item.color,
                          fontWeight: 700,
                        }}
                      >
                        {item.value}
                      </Typography>
                    </Stack>
                    <Typography sx={{ fontSize: 11, color: "#a7adbc", ml: "20px", mt: "-5px" }}>alerts</Typography>
                  </Paper>
                ))}
              </Stack>
            </Paper>
          </Stack>
        
        
        </Box>
      </Box>

      <Dialog
        open={dialog.open}
        onClose={() => setDialog({ open: false, message: "" })}
        PaperProps={{
          sx: {
            background: "#1f232d",
            color: "#e6e8ee",
            borderRadius: 2,
            border: "1px solid rgba(255,255,255,0.08)",
          },
        }}
      >
        <DialogTitle>Test Dialog</DialogTitle>
        <DialogContent>
          <Typography>{dialog.message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDialog({ open: false, message: "" })}
            variant="contained"
            sx={{
              background: "#2b68c4",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { background: "#255ab0" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
